// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTermAcceptances_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /lgpd_term_acceptances/save
 *
 * Records a client's acceptance of an LGPD term.
 * The snapshot fields (termo_titulo, termo_versao, termo_conteudo) are
 * populated by the controller from the referenced lgpd_terms record.
 */
import { registerContract } from './validate'

export interface LgpdTermAcceptances_SaveInput {
cliente_id: number
term_id: number
}

registerContract('LgpdTermAcceptances_SaveInput', {
  cliente_id: { type: 'number',  required: true },
  term_id:    { type: 'number',  required: true },
})
